/* eslint-disable react/prop-types */
import React from "react";

import { Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/modal";
import { Button } from "@nextui-org/button";

const ConfirmApproveModal = ({
  isOpen,
  onOpenChange,
  onConfirm,
  onCancel,
  description,
  title,
  headerColor,
  confirmColor,
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        closeButton={
          <svg
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: "absolute",
              right: "16px",
              top: "14px",
              background: "transparent",
            }}
          >
            <path
              d="M6 18L18 6M6 6L18 18"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader
                className={`${headerColor ?? "bg-blue-500"} text-white`}
              >
                {title}
              </ModalHeader>
              <ModalBody className="py-8 px-3 flex items-center gap-y-5">
                <div className="">{description}</div>
                <div className="flex flex-col md:flex-row md:gap-x-3 gap-y-3 justify-center">
                  <Button
                    className={`${
                      confirmColor ?? "bg-blue-500"
                    } text-white mx-5 px-16`}
                    onPress={onConfirm}
                  >
                    ยืนยัน
                  </Button>
                  <Button
                    className="bg-light-gray-300 text-white mx-5 px-16"
                    variant="light"
                    onPress={() => {
                      if(onCancel) onCancel()
                      onClose()
                    }}
                  >
                    ยกเลิก
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default ConfirmApproveModal;
